import { Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnChanges, OnDestroy, OnInit, Optional, Output, SimpleChanges, ViewChild } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { HttpClient } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';

import { interval, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { ExecuteService } from 'src/app/Services/execute.service';
import { ParameterService } from 'src/app/Services/parameter.service';
import { SharedService } from 'src/app/Services/shared.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { UserService } from 'src/app/Services/user.service';
import { ActionServiceService } from 'src/app/Services/action-service.service';
import { OrganisationService } from 'src/app/Services/organisation.service';
import { MobileStreamService } from 'src/app/Services/mobile-stream.service';
import { FeatureAccessService } from 'src/app/Services/feature-access.service';

import { ExecutionModel } from '../../Models/execution-model';
import { LocalExecutionUrlModel } from 'src/app/Models/local-execution-url-model';
import { ActionModel } from 'src/app/Models/action-model';
import { ExecutionConfigModel } from 'src/app/Models/execution-config-model';

import { TopNavComponentComponent } from '../top-nav-component/top-nav-component.component';
import { CsvWarningDialogComponent, CsvWarningDialogModel } from '../csv-warning-dialog/csv-warning-dialog.component';

import { Utilities } from 'src/app/utilities';
import { Literals } from 'src/app/literals';
import { DEVICE_RESOLUTIONS } from 'src/app/Constant/device.constants';
import { BASE_RESOLUTIONS } from 'src/app/Constant/resolution.constants';
import { DELAY_LIST } from 'src/app/Constant/delay.constants';
import { getBrand } from 'src/environments/brand';

@Component({
  selector: 'ze-execution-container',
  templateUrl: './execution-container.component.html',
  styleUrls: ['./execution-container.component.scss']
})
export class ExecutionContainerComponent implements OnInit, OnDestroy, OnChanges {
  brand = getBrand();
  @ViewChild('webHostDropdown', { static: false }) webHostDropdownRef: ElementRef<HTMLElement>;
  @ViewChild('mobileHostDropdown', { static: false }) mobileHostDropdownRef: ElementRef<HTMLElement>;

  public localExecutionUrlModel: LocalExecutionUrlModel;
  public executionModel: ExecutionModel = new ExecutionModel();
  @Input() forceOpen: boolean = false;
  @Input() hideControls: boolean = false;
  @Input() hideCloseIcon: boolean = false;
  @Input() showDiv: boolean = true;
  @Input() dropped_suite: any;
  @Input() hideUpload: boolean = false;
  @Input() hideSuiteName: boolean = false;
  @Input() hideSetCsv: boolean = false;
  @Input() hideLocalExecutionOptions: boolean = false;
  /** Merged: Input flag OR access-denied. True means local execution APIs won't be called. */
  get isLocalExecutionBlocked(): boolean {
    return this.hideLocalExecutionOptions || this.featureAccessService.getAccess('LOCAL_EXECUTION') !== 'WRITE';
  }
  @Input() hideMobileDevice: boolean = false;
  @Input() hideDownloadAndFeedButton: boolean = false;
  @Input() disableAi: boolean = false;
  @Input() editMode: boolean = false;
  @Input() initialExecutionTypes: string[] = ['web'];
  @Input() masterExecutionConfig: any = null;
  @Output() csvFileStateChange = new EventEmitter<void>();
  @Output() parametersAvailableChange = new EventEmitter<boolean>();
  @Output() executionTypesChange = new EventEmitter<string[]>();
  @Output() csvFileChange = new EventEmitter<File | null>();
  @Output() apkFileChange = new EventEmitter<File | null>();
  public executionConfig: ExecutionConfigModel;

  baseUrl: string = environment.backendEndpoint + ":8080/";
  deviceResolutions = DEVICE_RESOLUTIONS;

  public showDialog: boolean = false;
  public isParametersAvailable: boolean = false;
  public isAIGenerated: boolean = false;
  public isSetTimeDisabled: boolean = true;
  public resetFile: Boolean = false;
  openByFlag: boolean = false;
  isDialog: boolean = false;
  isDefaultCsvFile: boolean = false;
  isFromGenerateTestCase: boolean = false;

  selectedMode: string = 'manual';
  selectedOption: string = '';
  showDropdown: boolean = false;
  showMobileDropdown: boolean = false;

  public paramters: any[] = [];
  public items: [] = [];
  /** Local execution hosts for web (API type `web`) */
  public listofUser: any[] = [];
  /** Local execution hosts for mobile (API type `mobile`) */
  public listofUserMobile: any[] = [];

  public browserList: string[];
  public delayList;
  public resolutionList;
  public defaultResolution = "default_resolution";

  public aiIntelligenceList: { name: string; value: string; featureCode: string; disabled?: boolean }[] = [
    { name: 'Regular', value: 'Regular', featureCode: 'AI_INTELLIGANCE_REGULAR' },
    { name: 'Intermediate', value: 'Intermediate', featureCode: 'AI_INTELLIGANCE_INTERMEDIATE' },
    { name: 'Pro', value: 'Pro', featureCode: 'AI_INTELLIGANCE_PRO' }
  ];
  public selectedAiIntelligence: string='';

  public lockStatus: string = 'lock_open';
  private hasManualExecutionTypeChange = false;

  file: File;

  public get hasUploadedCsv(): boolean {
    return !!this.file;
  }

  /** CSV picked for schedule upload (FormData). */
  getUploadedCsvFile(): File | null {
    return this.file || null;
  }

  public get existingCsvFileName(): string {
    const csvPath = this.dropped_suite && this.dropped_suite.csv_path ? this.dropped_suite.csv_path : '';
    if (!csvPath) {
      return '';
    }
    const normalized = csvPath.replace(/\\/g, '/');
    return normalized.split('/').pop() || normalized;
  }

  useDefaultCsv: boolean = false;
  setCsvForSuite: boolean = false;
  hasSuiteCsv: boolean = false;

  apkFile: File | null = null;
  apkFileName: string = '';
  /** CSV already stored on schedule (from attached_files), shown in edit mode. */
  scheduleAttachedCsvPath: string | null = null;
  scheduleAttachedCsvLabel = '';
  /** APK already stored on schedule (from attached_files), shown in edit mode. */
  scheduleAttachedApkPath: string | null = null;
  scheduleAttachedApkLabel = '';
  /** User clicked Reset on a schedule-attached CSV/APK — triggers file upload API on save. */
  scheduleCsvResetRequested = false;
  scheduleApkResetRequested = false;
  private pendingScheduleEmulators: any[] = [];
  /** When true, run on Xpeer Mobile Hub — hides local device/APK UI */
  runOnXpeerMobileHub = true;

  /** When hub is off, set after picking a local host so getDeviceDetails uses `localExecutionUrls` */
  selectedLocalMobileExecutionUrls: string[] | null = null;
  /** Custom IP applies to mobile local flow (not web dropdown) */
  customMobileIpMode = false;

  xDimension: number = 1920;
  yDimension: number = 1200;
  haveDeviceResolutions: boolean;

  setLimit: number = 0;

  customIp = '';
  CustomeIP: any = "";
  exePort: any = "";
  inputboxDisables: boolean = true;
  isCustomIpSelected = false;
  isMobileDeveloperSelected = false;
  public _isURLWithoutPORT = false;

  testCaseId: string = "";

  executionTypes: string[] = ['web', 'mobile'];
  selectedExecutionTypes: string[] = ['web'];
  private previousExecutionTypes: string[] = ['web'];
  private lastAppliedMasterExecutionConfigSignature = '';

  /** Full list from getDeviceDetails; filtered by getEmulatorsStatus keys for the dropdown */
  private allEmulators: any[] = [];
  emulatorList: any[] = [];
  selectedEmulators: any[] = [];
  emulatorStatusMap: { [id: string]: any } = {};
  private emulatorStatusPollSub: Subscription | null = null;
  private accessMapSub: Subscription | null = null;
  private isDestroyed = false;
  // ===== CSV =====

  // ===== APK =====
  useDefaultApk: boolean = false;
  setApkForSuite: boolean = false;
  hasSuiteApk: boolean = false;

  constructor(
    public executeService: ExecuteService,
    private router: Router,
    private parameterService: ParameterService,
    private _sharedService: SharedService,
    private actionService: ActionServiceService,
    private route: ActivatedRoute,
    private notifys: NotifyService,
    private userService: UserService,
    private http: HttpClient,
    private organisationService: OrganisationService,
    private dialog: MatDialog,
    private mobileExecutionService: MobileStreamService,
    private featureAccessService: FeatureAccessService,
    @Optional() public dialogRef?: MatDialogRef<ExecutionContainerComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData?: any
  ) {
    this.browserList = ["Chrome", "Firefox", "Opera"];
    this.delayList = DELAY_LIST;
    this.updateResolutionList(true);

    this.isDialog = !!dialogRef;
    if (this.isDialog) {
      this.executionConfig = dialogData.executionConfig;
      this.executionModel = new ExecutionModel();
      if (this.executionConfig.browser !== undefined && this.executionConfig.browser !== null) {
        this.executionModel.browser = this.executionConfig.browser
      }
      if (this.executionConfig.resolution !== undefined && this.executionConfig.resolution !== null) {
        this.executionModel.resolution = this.executionConfig.resolution;
      }
      if (this.executionConfig.hub_ip !== undefined && this.executionConfig.hub_ip !== null) {
        this.executionModel.hub_ip = this.executionConfig.hub_ip;
      }
      if (this.executionConfig.port !== undefined && this.executionConfig.port !== null) {
        this.executionModel.port = this.executionConfig.port;
      }
      if (this.executionConfig.send_mail !== undefined && this.executionConfig.send_mail !== null) {
        this.executionModel.send_mail = this.executionConfig.send_mail;
      }
      if (this.executionConfig.default_pause !== undefined && this.executionConfig.default_pause !== null) {
        this.executionModel.default_pause = this.executionConfig.default_pause;
      }
      if (this.executionConfig.screenshot_required !== undefined && this.executionConfig.screenshot_required !== null) {
        this.executionModel.screenshot_required = this.executionConfig.screenshot_required;
      }
      if (this.executionConfig.default_hub !== undefined && this.executionConfig.default_hub !== null) {
        this.executionModel.default_hub = this.executionConfig.default_hub;
      }
      if (this.executionConfig.execution_machine !== undefined && this.executionConfig.execution_machine !== null) {
        this.executionModel.execution_machine = this.executionConfig.execution_machine;
      }
      if (this.executionConfig.local_execution !== undefined && this.executionConfig.local_execution !== null) {
        this.executionModel.local_execution = this.executionConfig.local_execution;
        this.getExecutionUrls();
      }
      if (this.executionConfig.selected_option !== undefined && this.executionConfig.selected_option !== null) {
        this.selectedOption = this.executionConfig.selected_option;
      }
      if (this.executionConfig.is_user_hub !== undefined && this.executionConfig.is_user_hub !== null) {
        this.inputboxDisables = this.executionConfig.is_user_hub;
      }
      if (this.executionConfig.xDimension !== undefined && this.executionConfig.xDimension !== null) {
        this.xDimension = this.executionConfig.xDimension;
      }
      if (this.executionConfig.yDimension !== undefined && this.executionConfig.yDimension !== null) {
        this.yDimension = this.executionConfig.yDimension;
      }
      if (this.executionConfig.is_url_without_port !== undefined && this.executionConfig.is_url_without_port !== null && this.executionConfig.is_url_without_port) {
        this._isURLWithoutPORT = this.executionConfig.is_url_without_port;
      }
      if (dialogData.datasetLink != "") {
        this.isDefaultCsvFile = true;
      }

      this.dropped_suite = dialogData.dropped_suite;
      this.testCaseId = dialogData.testCaseId;
      this.isFromGenerateTestCase = dialogData.isFromGenerateTestCase || false;
      this.updateContainer();
    } else {
      this.executionModel = new ExecutionModel();
      this.executionModel.resolution = this.defaultResolution;
      this.executionModel.browser = ["Chrome"];
      this.executionModel.default_pause = "0";
      this.executionModel.screenshot_required = false;
      this.executionModel.default_hub = true;
      this.executionModel.local_execution = false;
      this.executionModel.send_mail = false;
    }
  }

  ngOnInit() {
    this.lockStatus = 'lock_open';

    // Wait for the project access map to be populated before initializing
    // execution types. The map is null while loading (or on first page load
    // before the API responds), so a synchronous call here would see every
    // feature as HIDDEN and incorrectly strip valid types.
    const map$ = this.featureAccessService.accessMap;
    if (this.featureAccessService.isLoaded) {
      // Already loaded (e.g. user navigated from another page)
      this.initializeAllowedExecutionTypes();
    } else {
      // Wait for the first non-null emission (API response after refresh)
      this.accessMapSub = map$
        .pipe(filter(m => m !== null), take(1))
        .subscribe(() => this.initializeAllowedExecutionTypes());
    }
  }

  initializeAllowedExecutionTypes() {
  this.selectedExecutionTypes = this.filterAllowedExecutionTypes(this.selectedExecutionTypes);

  if (this.selectedExecutionTypes.length === 0) {
    if (this.showWebExecutionType() && !this.disableWebExecutionType()) {
      this.selectedExecutionTypes = ['web'];
    } else if (this.showMobileExecutionType() && !this.disableMobileExecutionType()) {
      this.selectedExecutionTypes = ['mobile'];
    }
  }
  this.initializeAiIntelligenceSelection();
}

private initializeAiIntelligenceSelection(): void {
  const current = this.aiIntelligenceList.find(o => o.value === this.selectedAiIntelligence);
  const currentIsWritable = !!current && this.featureAccessService.isWritable(current.featureCode);
  if (currentIsWritable) {
    return;
  }
  const firstWritable = this.aiIntelligenceList.find(o => this.featureAccessService.isWritable(o.featureCode));
  // if (firstWritable) {
  //   this.selectedAiIntelligence = firstWritable.value;
  //   return;
  // }
  // const visible = this.visibleAiIntelligenceOptions;
  // this.selectedAiIntelligence = visible.length > 0 ? visible[0].value : '';
   // If nothing is writable, leave it unset rather than defaulting to a
  // DISABLED/READ_ONLY tier the user has no access to select.
  this.selectedAiIntelligence = firstWritable ? firstWritable.value : '';
}

  /** Removes any execution type that is hidden OR visible-but-not-writable (DISABLED). */
private filterAllowedExecutionTypes(types: string[]): string[] {
  return (types || []).filter(t => {
    if (t === 'web') {
      return this.showWebExecutionType() && !this.disableWebExecutionType();
    }
    if (t === 'mobile') {
      return this.showMobileExecutionType() && !this.disableMobileExecutionType();
    }
    return false;
  });
}

  showWebExecutionType(): boolean {
    return this.featureAccessService.isVisible('WEB_AUTOMATION') || this.featureAccessService.isVisible('LOCAL_EXECUTION');
  }

  disableWebExecutionType(): boolean {
    return this.featureAccessService.getAccess('WEB_AUTOMATION') !== 'WRITE' && this.featureAccessService.getAccess('LOCAL_EXECUTION') !== 'WRITE';
  }

  showMobileExecutionType(): boolean {
    return this.featureAccessService.isVisible('MOBILE_AUTOMATION');
  }

  disableMobileExecutionType(): boolean {
    return this.featureAccessService.getAccess('MOBILE_AUTOMATION') !== 'WRITE';
  }

  /** Only options that are not HIDDEN get rendered at all */
get visibleAiIntelligenceOptions() {
  return this.aiIntelligenceList.filter(o => this.featureAccessService.isVisible(o.featureCode));
}

/** Dropdown itself only shows if at least one tier is more than HIDDEN */
get showAiIntelligenceDropdown(): boolean {
  return this.visibleAiIntelligenceOptions.length > 0;
}

/** READ_ONLY and DISABLED both render but are not clickable — only WRITE is */
isAiIntelligenceOptionDisabled(option: { featureCode: string }): boolean {
  return !this.featureAccessService.isWritable(option.featureCode);
}



  ngOnChanges(changes: SimpleChanges) {
    if (changes.dropped_suite && this.dropped_suite && !this.isDialog) {
      this.updateContainer();
    }

    if (changes.masterExecutionConfig && this.masterExecutionConfig && !this.isDialog) {
      this.applyMasterExecutionConfigInput(this.masterExecutionConfig);
    }

    if (changes.initialExecutionTypes && !this.isDialog) {
      const types = changes.initialExecutionTypes.currentValue as string[];
      if (!this.hasManualExecutionTypeChange && Array.isArray(types) && types.length) {
        const allowed = this.filterAllowedExecutionTypes(types);
        this.selectedExecutionTypes = allowed.length ? allowed : this.selectedExecutionTypes;
        this.previousExecutionTypes = [];
        this.onExecutionTypeChange();
      }
    }
  }

  public setInitialExecutionTypes(types: string[]): void {
    const allowed = this.filterAllowedExecutionTypes(types);
    if (allowed.length) {
      this.hasManualExecutionTypeChange = true;
      this.selectedExecutionTypes = types.slice();
      this.previousExecutionTypes = types.slice();
      this.executionTypesChange.emit(this.selectedExecutionTypes.slice());

      if (this.isMobileExecution()) {
        if (this.runOnXpeerMobileHub) {
          this.getMobileDevice();
        } else if (!this.isLocalExecutionBlocked) {
          this.getExecutionUrls('mobile');
        }
      } else {
        this.selectedEmulators = [];
        this.stopEmulatorStatusPolling();
        this.clearApkFile();
      }
    }
  }

  private applyMasterExecutionConfigInput(masterConfig: any): void {
    const signature = this.getMasterExecutionConfigSignature(masterConfig);
    if (!signature || signature === this.lastAppliedMasterExecutionConfigSignature) {
      return;
    }

    this.lastAppliedMasterExecutionConfigSignature = signature;
    this.applyScheduleMasterConfig(masterConfig);
  }

  private getMasterExecutionConfigSignature(masterConfig: any): string {
    if (!masterConfig) {
      return '';
    }

    try {
      return JSON.stringify(masterConfig);
    } catch (error) {
      return String(Date.now());
    }
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    this.stopEmulatorStatusPolling();
    if (this.accessMapSub) { this.accessMapSub.unsubscribe(); }
  }

  selectOption(option: any, fromMobile = false) {
    this.inputboxDisables = true;
    this.selectedOption = option.username;
    this.executionModel.port = this.exePort;
    if (fromMobile) {
      this.showMobileDropdown = false;
      this.isCustomIpSelected = false;
      this.isMobileDeveloperSelected = true;
      this.customMobileIpMode = false;
      this.customIp = '';
      const url = option.localExecutionModels && option.localExecutionModels[0]
        ? option.localExecutionModels[0].url
        : null;
      if (url) {
        this.selectedLocalMobileExecutionUrls = [url];
        this.getMobileDevice({ localExecutionUrls: this.selectedLocalMobileExecutionUrls });
      }
    } else {
      this.showDropdown = false;
    }
    this.executionModel.hub_ip = option.localExecutionModels[0].url;
    this.executionModel.execution_machine = option.username + "'s Host"
    this.executionModel.local_execution = true;
    this.executionModel.default_hub = false;
  }

  selectOptionforCustom(cip: any, fromMobile = false) {
    this.inputboxDisables = false;
    this.selectedOption = "Custom IP"
    this.executionModel.port = this.exePort;
    this.isCustomIpSelected = true;
    this.isMobileDeveloperSelected = false;
    if (fromMobile) {
      this.showMobileDropdown = false;
      this.customMobileIpMode = true;
      this.selectedLocalMobileExecutionUrls = null;
      const ip = (this.customIp || '').trim();
      if (ip) {
        this.selectedLocalMobileExecutionUrls = [ip];
        this.getMobileDevice({ localExecutionUrls: this.selectedLocalMobileExecutionUrls });
      }
    } else {
      this.showDropdown = false;
      this.customMobileIpMode = false;
    }
    this.executionModel.local_execution = true;
    this.executionModel.default_hub = false;
  }

  onCustomMobileIpChange() {
    if (!this.customMobileIpMode || !this.isMobileExecution() || this.runOnXpeerMobileHub) {
      return;
    }
    const ip = (this.customIp || '').trim();
    if (!ip) {
      this.selectedLocalMobileExecutionUrls = null;
      this.stopEmulatorStatusPolling();
      this.selectedEmulators = [];
      this.clearApkFile();
      return;
    }
    this.selectedLocalMobileExecutionUrls = [ip];
    this.getMobileDevice({ localExecutionUrls: this.selectedLocalMobileExecutionUrls });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as Node | null;
    if (!target) {
      return;
    }

    // Close only when the click is outside *that* dropdown’s root. Using any
    // `.editable-dropdown` was wrong when web + mobile are both visible: a click
    // on the other row still matched `closest('.editable-dropdown')` and kept menus open.
    if (this.showDropdown) {
      const root = this.webHostDropdownRef && this.webHostDropdownRef.nativeElement;
      if (!root || !root.contains(target)) {
        this.showDropdown = false;
      }
    }
    if (this.showMobileDropdown) {
      const root = this.mobileHostDropdownRef && this.mobileHostDropdownRef.nativeElement;
      if (!root || !root.contains(target)) {
        this.showMobileDropdown = false;
      }
    }
  }

  toggleDropdown(state: boolean) {
    if (this.executionModel.default_hub) {
      this.inputboxDisables = false;
      this.showDropdown = false;
    } else {
      if (state) {
        this.showMobileDropdown = false;
      }
      this.showDropdown = state;
    }
  }

  toggleMobileDropdown(state: boolean) {
    if (state) {
      this.showDropdown = false;
    }
    this.showMobileDropdown = state;
  }

  onMobileHubCheckboxChange(): void {
    this.showMobileDropdown = false;
    this.selectedOption = ''; // reset selected host text on toggle
    this.selectedLocalMobileExecutionUrls = null;
    this.isCustomIpSelected = false;
    this.isMobileDeveloperSelected = false;
    this.customMobileIpMode = false;
    this.selectedEmulators = [];
    this.clearApkFile();
    this.stopEmulatorStatusPolling();

    if (this.runOnXpeerMobileHub) {
      // switch to Xpeer mobile hub mode: clear mobile local selection
      this.getMobileDevice();
    } else if (!this.isLocalExecutionBlocked) {
      // switch to local mobile mode: load local options when allowed
      this.getExecutionUrls('mobile');
    }
  }

  updateResolutionList(includeDeviceResolutions: boolean) {
    const baseResolutions = BASE_RESOLUTIONS;
    const customResolution = [{ name: "Custom Resolution", value: "custom_resolution" }];

    if (includeDeviceResolutions) {
      this.resolutionList = baseResolutions.concat(this.deviceResolutions).concat(customResolution);
      this.haveDeviceResolutions = true;
    } else {
      this.resolutionList = baseResolutions.concat(customResolution);
      this.haveDeviceResolutions = false;
    }
  }

  onBrowserChange(): void {
    if (this.executionModel.browser.length == 0 || (this.executionModel.browser.length == 1 && this.executionModel.browser[0] == "Chrome")) {
      if (!this.haveDeviceResolutions) {
        this.updateResolutionList(true);
      }
    } else {
      if (this.haveDeviceResolutions) {
        if (this.executionModel.resolution.startsWith("Device:")) {
          this.executionModel.resolution = this.defaultResolution;
        }
        this.updateResolutionList(false);
      }
    }
  }

  onCheckboxChange() {
    if (this.executionModel.default_hub) {
      this.executionModel.hub_ip = environment.selenoidHubIp;
      this.executionModel.execution_machine = "Default Machine";
      this.executionModel.port = environment.selenoidHubPort;
      this.selectedOption = '';
    } else {
      this.executionModel.default_hub = false;
      this.selectedOption = '';
      this.showDropdown = false;
      if (!this.isLocalExecutionBlocked) {
        this.getExecutionUrls('web');
      }
      this.executionModel.hub_ip = undefined;
      this.executionModel.port = undefined;
    }
  }

  getAlertMessage() {
    let tempMessage = "";
    let mySet1 = new Set();

    this.paramters.forEach(element => {
      for (const ele of element.commandSteps) {
        if ((ele.target && ((ele.target.deleted && ele.target.deleted == 1) || (ele.target.warnings && Object.keys(ele.target.warnings).length > 0))) ||
          (ele.target2 && ((ele.target2.deleted && ele.target2.deleted == 1) || (ele.target2.warnings && Object.keys(ele.target2.warnings).length > 0)))) {
          mySet1.add(element.name);
          break;
        }
      }
    });
    for (const value of mySet1) {
      tempMessage += "\n * " + value + "\n";
    }
    return tempMessage;
  }

  drop(ele) {
    this.dropped_suite = ele.previousContainer.data[ele.previousIndex];
    // Detect suite resources
    this.hasSuiteCsv = !!this.dropped_suite.csv_path;
    this.hasSuiteApk = !!this.dropped_suite.mobile_apk_path;

    // Default selection
    this.useDefaultApk = this.hasSuiteApk;

    // Reset "set for suite"
    this.setCsvForSuite = false;
    this.setApkForSuite = false;
    this.updateContainer();
  }

  updateContainer() {
    this.isParametersAvailable = false;
    this.hasSuiteCsv = !!this.dropped_suite.csv_path;
    this.hasSuiteApk = !!this.dropped_suite.mobile_apk_path;
    this.useDefaultApk = this.hasSuiteApk;
    if (this.dropped_suite._type.toLowerCase() === "suite") {
      this.executionModel.suite_id = this.dropped_suite._id;
      switch (this.dropped_suite._type.toLowerCase()) {
        case "suite":
          let db: number = 1;
          if (TopNavComponentComponent.currentPage.name.toUpperCase() === 'CANVAS') {
            db = 2;
          }
          this.parameterService.findBySuiteId(this.dropped_suite._id, db).subscribe((data) => {
            this.paramters = data.data;
            this._sharedService.loaderHide.emit(false);
            let message = this.getAlertMessage();
            if (message != "") {
              let warning_message = Utilities.EXECUTION_WARNING_MESSAGE + "\n";
              this.resetAll();
              alert(warning_message + message);
            } else {
              for (let i = 0; i < this.paramters.length; i++) {
                for (let j = 0; j < this.paramters[i].commandSteps.length; j++) {
                  if (this.paramters[i].commandSteps[j].active !== false) {
                    if (this.paramters[i].commandSteps[j].type == "API") {
                      const PLACEHOLDER_PATTERN = /\{\{@@[^}]+}}/;
                      let isAuthParametersAvailable = false;
                      let isHeadersParametersAvailable = false;
                      let isUrlParametersAvailable = false;
                      let isBodyParametersAvailable = false;
                      // check in authentication
                      if (this.paramters[i].commandSteps[j].target.request.auth
                        && this.paramters[i].commandSteps[j].target.request.auth.type) {
                        let authType = this.paramters[i].commandSteps[j].target.request.auth.type;
                        isAuthParametersAvailable = this.containsParameterPattern(this.paramters[i].commandSteps[j].target.request.auth[authType], PLACEHOLDER_PATTERN);
                      }

                      // check in headers
                      if (this.paramters[i].commandSteps[j].target.request.headers) {
                        isHeadersParametersAvailable = this.containsParameterPattern(this.paramters[i].commandSteps[j].target.request.headers, PLACEHOLDER_PATTERN);
                      }

                      // check in url
                      if (this.paramters[i].commandSteps[j].target.request.url) {
                        isUrlParametersAvailable = PLACEHOLDER_PATTERN.test(this.paramters[i].commandSteps[j].target.request.url.raw);
                      }

                      // check in request body
                      if (this.paramters[i].commandSteps[j].target.request.body
                        && this.paramters[i].commandSteps[j].target.request.body.mode) {
                        const bodyMode = this.paramters[i].commandSteps[j].target.request.body.mode;
                        switch (bodyMode) {
                          case "raw":
                            isBodyParametersAvailable = PLACEHOLDER_PATTERN.test(this.paramters[i].commandSteps[j].target.request.body.raw);
                            break;
                          case "formdata":
                            isBodyParametersAvailable = this.containsParameterPattern(this.paramters[i].commandSteps[j].target.request.body.formdata, PLACEHOLDER_PATTERN);
                            break;
                          case "urlencoded":
                            isBodyParametersAvailable = this.containsParameterPattern(this.paramters[i].commandSteps[j].target.request.body.urlencoded, PLACEHOLDER_PATTERN);
                            break;
                          case "file":
                            isBodyParametersAvailable = PLACEHOLDER_PATTERN.test(this.paramters[i].commandSteps[j].target.request.body.file.src);
                            break;
                          case "graphql":
                            isBodyParametersAvailable = PLACEHOLDER_PATTERN.test(this.paramters[i].commandSteps[j].target.request.body.graphql.query) || PLACEHOLDER_PATTERN.test(this.paramters[i].commandSteps[j].target.request.body.graphql.variables);
                            break;
                        }
                      }
                      if (isAuthParametersAvailable || isBodyParametersAvailable || isHeadersParametersAvailable || isUrlParametersAvailable) {
                        this.isParametersAvailable = true;
                      }
                    } else {
                      let value = this.paramters[i].commandSteps[j].value;
                      let value2 = this.paramters[i].commandSteps[j].value2;
                      if (Boolean(value) && value.startsWith("@@")) {
                        this.isParametersAvailable = true;
                      }
                      if (Boolean(value2) && value2.startsWith("@@")) {
                        this.isParametersAvailable = true;
                      }
                      if (this.paramters[i].commandSteps[j].target) {
                        this.updateParameterPresentInTarget(this.paramters[i].commandSteps[j].target);
                      }
                      if (this.paramters[i].commandSteps[j].target2) {
                        this.updateParameterPresentInTarget(this.paramters[i].commandSteps[j].target2);
                      }
                    }
                  }
                }
              }
            }
            this.applyDefaultCsvSelectionAfterParametersLoad();
          });
          break;
        case "feature":
          this.parameterService.findByFeatureId(this.dropped_suite._id).subscribe((data) => {
            this.paramters = data.data;
            this._sharedService.loaderHide.emit(false);
            this.applyDefaultCsvSelectionAfterParametersLoad();
          });
          break;
        case "scenario":
          this.parameterService.findByScenarioId(this.dropped_suite._id).subscribe((data) => {
            this.paramters = data.data;
            this._sharedService.loaderHide.emit(false);
            this.applyDefaultCsvSelectionAfterParametersLoad();
          });
          break;
      }
      if (!this.isDialog) {
        this.onCheckboxChange();
      }
    }
  }

  updateParameterPresentInTarget(target) {
    if (Boolean(target.dom_id) && target.dom_id.startsWith("@@")) {
      this.isParametersAvailable = true;
    }
    if (Boolean(target.dom_name) && target.dom_name.startsWith("@@")) {
      this.isParametersAvailable = true;
    }
    if (Boolean(target.tag) && target.tag.startsWith("@@")) {
      this.isParametersAvailable = true;
    }
    if (Boolean(target.css) && target.css.startsWith("@@")) {
      this.isParametersAvailable = true;
    }
    if (Boolean(target.class) && target.class.startsWith("@@")) {
      this.isParametersAvailable = true;
    }
    if (Boolean(target.desc) && target.desc.startsWith("@@")) {
      this.isParametersAvailable = true;
    }
    if (Boolean(target.link) && target.link.startsWith("@@")) {
      this.isParametersAvailable = true;
    }
    if (Boolean(target.partial_link) && target.partial_link.startsWith("@@")) {
      this.isParametersAvailable = true;
    }
    if (Boolean(target.horizontal_index) && target.horizontal_index.startsWith("@@")) {
      this.isParametersAvailable = true;
    }
    if (target.xpaths && target.xpaths.length > 0) {
      for (const xpath of target.xpaths) {
        if (Boolean(xpath) && xpath.startsWith("@@")) {
          this.isParametersAvailable = true;
          break;
        }
      }
    }
  }

  extractParametersFromString(input: string, pattern: any): string[] {
    if (!input || typeof input !== 'string') return [];
    const matches = input.match(pattern);
    return matches ? matches : [];
  }

  extractParametersFromAttributes(attributes: any[], pattern: any): string[] {
    if (attributes == undefined || attributes == null || !Array.isArray(attributes)) return [];

    const results: string[] = [];

    for (const attr of attributes) {
      if (attr.disabled === true) continue;

      // Always check key
      const keyMatches = this.extractParametersFromString(attr.key, pattern);
      for (let i = 0; i < keyMatches.length; i++) {
        results.push(keyMatches[i]);
      }

      if (attr.type === 'file' && Array.isArray(attr.src)) {
        for (const src of attr.src) {
          const srcMatches = this.extractParametersFromString(src, pattern);
          for (let i = 0; i < srcMatches.length; i++) {
            results.push(srcMatches[i]);
          }
        }
      } else {
        const valueMatches = this.extractParametersFromString(attr.value, pattern);
        for (let i = 0; i < valueMatches.length; i++) {
          results.push(valueMatches[i]);
        }
      }
    }
    return results;
  }

  containsParameterPattern(attributes: any, PLACEHOLDER_PATTERN: any): boolean {
    if (attributes == undefined || attributes == null || !Array.isArray(attributes)) return false;

    return attributes.some(attr => {
      if (attr.disabled === true) return false;
      if (PLACEHOLDER_PATTERN.test(attr.key || '')) return true;

      if (attr.type === 'file') {
        if (Array.isArray(attr.src)) {
          return attr.src.some((s: string) => PLACEHOLDER_PATTERN.test(s));
        }
        return false;
      }
      return PLACEHOLDER_PATTERN.test(attr.value || '');
    });
  }

  resetAll() {
    this.executionModel = { suite_id: undefined, browser: ["Chrome"], hub_ip: undefined, port: undefined, default_pause: "0", is_implicit_default_pause: false, send_mail: false, resolution: this.defaultResolution, screenshot_required: false, default_hub: true, local_execution: false, execution_machine: undefined };
    this.file = null;
    this.clearApkFile();
    this.stopEmulatorStatusPolling();
    this.selectedExecutionTypes = ['web'];
    this.previousExecutionTypes = ['web'];
    this.selectedEmulators = [];
    this.selectedOption = '';
    this.showDropdown = false;
    this.showMobileDropdown = false;
    this.inputboxDisables = true;
    this._isURLWithoutPORT = false;
    this.isCustomIpSelected = false;
    this.isMobileDeveloperSelected = false;
    this.customIp = '';
    this.CustomeIP = "";
    this.exePort = "";
    if (this.isDialog && this.isDefaultCsvFile) {
      this.isDefaultCsvFile = false;
    } else {
      this.resetFile = true;
    }
    this.showDialog = false;
    this.selectedMode = 'manual';
    this.isSetTimeDisabled = true;
    this.isAIGenerated = false;
    this.setLimit = 0;
    this.executionModel.default_hub = true;
    this.xDimension = 1920;
    this.yDimension = 1200;
    this.runOnXpeerMobileHub = true;
    this.selectedLocalMobileExecutionUrls = null;
    this.customMobileIpMode = false;
  }

  reset() {
    this.executionModel = { suite_id: this.executionModel.suite_id, browser: undefined, hub_ip: undefined, port: undefined, default_pause: undefined, is_implicit_default_pause: false, send_mail: false, resolution: this.defaultResolution, screenshot_required: false, default_hub: true, local_execution: false, execution_machine: undefined };
    this.file = null;
    this.clearApkFile();
    if (this.isDialog && this.isDefaultCsvFile) {
      this.isDefaultCsvFile = false;
    } else {
      this.resetFile = true;
    }
    this.executionModel.default_hub = true;
    this.onCheckboxChange();
    this.xDimension = 1920;
    this.yDimension = 1200;
    this.runOnXpeerMobileHub = true;
    this.selectedLocalMobileExecutionUrls = null;
    this.customMobileIpMode = false;
    this.isCustomIpSelected = false;
    this.isMobileDeveloperSelected = false;
  }
  fileAdded(file) {
    this.resetFile = false;
    this.file = file;
    this.csvFileChange.emit(file);
  }

  /** Edit mode: user removes schedule-attached CSV so they can upload or pick suite default. */
  resetScheduleAttachedCsv(): void {
    this.scheduleCsvResetRequested = true;
    this.scheduleAttachedCsvPath = null;
    this.scheduleAttachedCsvLabel = '';
    this.useDefaultCsv = false;
    this.resetFile = true;
    this.csvFileChange.emit(null);
  }

  /** @deprecated Use resetScheduleAttachedCsv in edit mode. */
  resetExistingCsv(): void {
    this.resetScheduleAttachedCsv();
  }

  /** Edit mode: user removes schedule-attached APK so they can upload or pick suite default. */
  resetScheduleAttachedApk(apkInput?: HTMLInputElement): void {
    this.scheduleApkResetRequested = true;
    this.scheduleAttachedApkPath = null;
    this.scheduleAttachedApkLabel = '';
    this.useDefaultApk = false;
    this.clearApkFile(apkInput);
  }

  private applyDefaultCsvSelectionAfterParametersLoad(): void {
    if (this.editMode) {
      this.useDefaultCsv = !!this.scheduleAttachedCsvPath;
      this.parametersAvailableChange.emit(this.isParametersAvailable);
      return;
    }
    this.useDefaultCsv = this.isParametersAvailable && this.hasSuiteCsv;
    this.parametersAvailableChange.emit(this.isParametersAvailable);
  }

  public isCsvUploadRequired(): boolean {
    return this.showCsvUploadZone() && this.isParametersAvailable && !this.useDefaultCsv && (!this.file || this.file == null);
  }

  /** True when the CSV upload controls should be visible. */
  showCsvUploadZone(): boolean {
    if (this.editMode && this.scheduleAttachedCsvPath && this.useDefaultCsv && !this.file) {
      return false;
    }

    if (this.editMode && !this.scheduleAttachedCsvPath && !this.scheduleCsvResetRequested) {
      return false;
    }

    return true;
  }

  public isApkUploadRequired(): boolean {
    return this.showApkUploadZone() && this.isMobileExecution() && this.showMobileDeviceAndApkPanel && !this.useDefaultApk && (!this.apkFile || this.apkFile == null);
  }

  /** True when the APK drop zone / new upload UI should be visible. */
  showApkUploadZone(): boolean {
    if (this.editMode && this.scheduleAttachedApkPath && this.useDefaultApk && !this.apkFile) {
      return false;
    }
    if (!this.hasSuiteApk && !this.scheduleAttachedApkPath) {
      return true;
    }
    return !this.useDefaultApk;
  }

  parseJwt(token: string): any {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }

  onDefaultPauseChange(value: any) {
    if (value === 0 || value === '0') {
      this.executionModel.is_implicit_default_pause = false;
    }
  }

  execute() {
  if (this.isMobileExecution() && !this.useDefaultApk && (!this.apkFile || this.apkFile == null)) {
    this.notifys.notify('error', 'Error', 'You must upload an APK file when mobile execution is selected.');
    return;  // ← add return and close the if-block
  }
  if (this.isMobileExecution() && this.showMobileDeviceAndApkPanel &&
    (!this.selectedEmulators || this.selectedEmulators.length === 0)) {
    this.notifys.notify('error', 'Error', 'Select at least one mobile device.');
    return;
  }
  if (this.isMobileExecution() && this.showMobileDeviceAndApkPanel && !this.useDefaultApk &&
    (!this.apkFile || this.apkFile == null)) {
    this.notifys.notify('error', 'Error', 'Upload an APK for mobile execution.');
    return;
  }

  if (this.isParametersAvailable && !this.useDefaultCsv && (!this.file || this.file == null) && (!this.isDefaultCsvFile || !this.isDialog)) {
    const message = 'You have not uploaded a CSV file. Your suite contains CSV data, and processing without it may fail. Do you want to proceed anyway?';
    const dialogData = new CsvWarningDialogModel('CSV File Warning', message);
    const dialogRef = this.dialog.open(CsvWarningDialogComponent, {
      width: '520px',
      maxWidth: '90vw',
      data: dialogData,
      panelClass: 'csv-warning-dialog-panel'
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult === true) {
        this.proceedWithExecution();
      }
    });
    return;
  }
  this.proceedWithExecution();
}  // ← this closing brace was effectively misplaced due to the unclosed if above

  proceedWithExecution() {
    const storedLicenseId = localStorage.getItem('licenseId');
    const licenseId = storedLicenseId && storedLicenseId !== 'null' ? storedLicenseId : null;
    const currentUserStr = localStorage.getItem('currentUser');

    if (!currentUserStr) {
      this.notifys.notify('error', 'Error', 'User not found. Please login again.');
      return;
    }

    const currentUser = JSON.parse(currentUserStr);
    if (!currentUser || !currentUser.token) {
      this.notifys.notify('error', 'Error', 'Token not found. Please login again.');
      return;
    }

    const parsedToken = this.parseJwt(currentUser.token);
    const userName = parsedToken.sub;
    if (!userName) {
      this.notifys.notify('error', 'Error', 'Unable to extract username from token.');
      return;
    }

    const projectId = localStorage.getItem('projectId');
    if (!projectId) {
      this.notifys.notify('error', 'Error', 'Project ID not found.');
      return;
    }

    const runExecution = (payloadLicenseId: string | null) => {
      const executionPayload: any = { ...this.executionModel };
      executionPayload.aiIntelligence = this.selectedAiIntelligence;
      if (this.inputboxDisables == false) {
        executionPayload.hub_ip = this.selectedOption;
      }
      if (!this.executionModel.default_hub && this._isURLWithoutPORT) {
        executionPayload.port = -1;
      }
      if (this.isMobileDeveloperSelected) {
        executionPayload.port = "-1";
      }
      let computedResolution = executionPayload.resolution;
      if (this.isDialog) {
        this.executionConfig.resolution = computedResolution;
      }
      if (computedResolution === "default_resolution") {
        computedResolution = "1920x1200";
      } else if (computedResolution === "custom_resolution") {
        if (this.isDialog) {
          this.executionConfig.xDimension = this.xDimension;
          this.executionConfig.yDimension = this.yDimension;
        }
        computedResolution = this.xDimension + "x" + this.yDimension;
      }
      executionPayload.resolution = computedResolution;
      executionPayload.is_implicit_default_pause = (this.executionModel.default_pause != undefined && this.executionModel.default_pause !== '0') ? this.executionModel.is_implicit_default_pause : false;
      executionPayload.license_id = payloadLicenseId;

      // Suite resource config — all false by default.
      // use_csv:    true when user selects "Use Default CSV (Suite)" radio
      // update_csv: true when user uploads a new CSV AND checks "Set as default for Suite"
      // use_apk:    true when user selects the suite's existing default APK
      // update_apk: true when user uploads a new APK AND checks "Set as default for Suite"
      // use_ipa / update_ipa: reserved for future IPA support
      const suiteResourceConfig = {
        use_csv:    this.useDefaultCsv,
        update_csv: !this.useDefaultCsv && this.setCsvForSuite,
        use_apk:    this.useDefaultApk || this.setApkForSuite,
        update_apk: !this.useDefaultApk && this.setApkForSuite,
        use_ipa:    false,
        update_ipa: false
      };

      if (this.isWebExecution() && !this.isMobileExecution()) {
        // Web only
        executionPayload.execution_type = 'Grid';
        executionPayload.emulators = undefined;
      } else if (!this.isWebExecution() && this.isMobileExecution()) {
        // Mobile only
        executionPayload.execution_type = 'Mobile';
        if (this.selectedEmulators && this.selectedEmulators.length > 0) {
          // Map emulator objects to expected format
          executionPayload.emulators = this.selectedEmulators.map(emulator => ({
            device_id: emulator._id,
            mobileOs: emulator.platform,
            mobileEmulator: emulator.udid,
            mobileHubIp: emulator.domain + '.xpeer.ai',
            mobileHubPort: emulator.hub_port.toString(),
            hub_name: emulator.domain || '',
            device_name: emulator.device_name || emulator.udid || ''
          }));
        } else {
          executionPayload.emulators = undefined;
        }
      } else if (this.isWebExecution() && this.isMobileExecution()) {
        // Both Web and Mobile selected - default to Grid for execution_type
        executionPayload.execution_type = 'Grid';
        if (this.selectedEmulators && this.selectedEmulators.length > 0) {
          executionPayload.emulators = this.selectedEmulators.map(emulator => ({
            device_id: emulator._id,
            mobileOs: emulator.platform,
            mobileEmulator: emulator.udid,
            mobileHubIp: emulator.hub_ip,
            mobileHubPort: emulator.hub_port ? emulator.hub_port.toString() : emulator.system_port ? emulator.system_port.toString() : '',
            hub_name: emulator.domain || '',
            device_name: emulator.device_name || emulator.udid || ''
          }));
        } else {
          executionPayload.emulators = undefined;
        }
      }

      if (this.isDialog) {
        this.executionConfig.browser = executionPayload.browser;
        this.executionConfig.screenshot_required = executionPayload.screenshot_required;
        this.executionConfig.port = executionPayload.port;
        this.executionConfig.default_pause = executionPayload.default_pause;
        this.executionConfig.send_mail = executionPayload.send_mail;
        this.executionConfig.execution_machine = executionPayload.execution_machine;
        this.executionConfig.default_hub = executionPayload.default_hub;
        this.executionConfig.local_execution = executionPayload.local_execution;
        this.executionConfig.hub_ip = executionPayload.hub_ip;
        this.executionConfig.is_url_without_port = this._isURLWithoutPORT;
        this.executionConfig.selected_option = this.selectedOption;
        this.executionConfig.is_user_hub = this.inputboxDisables;

        // Use DB2 endpoint if triggered from generate-test-case component, otherwise use regular endpoint
        const executeMethod = this.isFromGenerateTestCase
          ? this.executeService.executeTestCaseSuiteForDb2(executionPayload, this.executionConfig, this.testCaseId, this.isDefaultCsvFile, this.file, this.apkFile, suiteResourceConfig)
          : this.executeService.executeTestCaseSuite(executionPayload, this.executionConfig, this.testCaseId, this.isDefaultCsvFile, this.file, this.apkFile, suiteResourceConfig);

        executeMethod.subscribe(data => {
          if (data['operationStatus'] !== 'ERROR') {
            const reportId = data['data'] || data;
            const params: any = { reportId: reportId };
            // If execution was triggered from Generate Test Case (DB2), open Canvas ('ide'), otherwise open Library ('exe')
            params.openTab = this.isFromGenerateTestCase ? 'canvas' : 'exe';
            this.router.navigate(['/report'], { queryParams: params });
          } else {
            this.notifys.notify('error', 'Error', "Cannot execute a empty suite");
          }
          this.dialogRef.close();
        }, error => {
          this.notifys.notify('error', 'Error', "Error in executing a suite");
          this.dialogRef.close();
        });
      } else if (TopNavComponentComponent.currentPage.name.toUpperCase() != 'CANVAS') {
        this.executeService.executeSuite(executionPayload, this.file, this.apkFile, suiteResourceConfig).subscribe(data => {
          if (data['operationStatus'] !== 'ERROR') {
            const reportId = data['data'] || data;
            this.router.navigate(['/report'], { queryParams: { reportId: reportId } });
          } else {
            this.notifys.notify('error', 'Error', "Cannot execute a empty suite");
          }
        }
        )
      }
      else {
        this.executeService.executeSuitedb2(executionPayload, this.file, this.apkFile, suiteResourceConfig).subscribe(data => {
          if (data['operationStatus'] !== 'ERROR') {
            const reportId = data['data'] || data;
            this.router.navigate(['/report'], { queryParams: { openTab: 'canvas', reportId: reportId } });
          } else {
            this.notifys.notify('error', 'Error', "Cannot execute a empty suite");
          }
        })
      }
    };

    // Determine executionType based on default_hub
    const executionType = this.executionModel.default_hub ? 'remoteExecution' : ((this.executionModel.execution_machine == "Default Machine") ? 'remoteExecution' : 'localExecution');

    // If no license, bypass quota validation and execute directly
    if (!licenseId) {
      runExecution(null);
      return;
    }

    let isDb2: Boolean = TopNavComponentComponent.currentPage.name.toUpperCase() == Literals.CANVAS;
    this.organisationService.executionQuotaAvailable(projectId, licenseId, executionType, isDb2).subscribe(
      (quotaResponse: any) => {
        if (quotaResponse && quotaResponse.operationStatus === 'SUCCESS') {
          const isQuotaAvailable = quotaResponse.data !== null && quotaResponse.data.canExecute;
          if (!isQuotaAvailable) {
            this.notifys.notify('error', 'Error', 'Execution quota not available. Please check your license limits.');
          } else {
            runExecution(licenseId);
          }
        } else {
          const errorMessage = (quotaResponse && quotaResponse.operationMessage) || 'Failed to check execution quota.';
          this.notifys.notify('error', 'Error', errorMessage);
        }
      },
      (error) => {
        console.error('Error checking execution quota:', error);
        this.notifys.notify('error', 'Error', 'Error checking execution quota. Please try again.');
      }
    );
  }

  getParamList(actionItemsList: ActionModel[]): { sheet1: any[]; sheet2: any[] } {
    let sheet1 = [];   // for params outside loop
    let sheet2 = [];   // for params inside loop
    let mainlist = [];
    let suiteHasHashInVar = false;

    let loopDepth = 0;

    for (let i = 0; i < this.paramters.length; i++) {
      for (let j = 0; j < this.paramters[i].commandSteps.length; j++) {
        let step = this.paramters[i].commandSteps[j];
        if (step.active === true || step.active === undefined) {
          let actionName = this.getActionNameById(actionItemsList, step.command.$oid);

          // Detect entering a loop
          if (actionName.includes("loop")) {
            loopDepth++;
          }
          let currentList = loopDepth > 0 ? sheet2 : sheet1;  // decide where to store

          if (this.paramters[i].commandSteps[j].type == "API") {
            const PLACEHOLDER_PATTERN = /\{\{@@[^}]+}}/g;

            // check in auth
            const auth = this.paramters[i].commandSteps[j].target.request.auth;
            if (auth && auth.type) {
              const authType = auth.type;
              const authAttrs = auth[authType];
              const authParameters = this.extractParametersFromAttributes(authAttrs, PLACEHOLDER_PATTERN);
              authParameters.forEach(parameter => {
                suiteHasHashInVar = true;
                const cleanParam = parameter.slice(2, -2); // removes '{{' and '}}'
                currentList.push(this.paramters[i].name + cleanParam);
              });
            }

            // check in headers
            const headers = this.paramters[i].commandSteps[j].target.request.headers;
            if (headers) {
              const headerParameters = this.extractParametersFromAttributes(headers, PLACEHOLDER_PATTERN);
              headerParameters.forEach(parameter => {
                suiteHasHashInVar = true;
                const cleanParam = parameter.slice(2, -2); // removes '{{' and '}}'
                currentList.push(this.paramters[i].name + cleanParam);
              });
            }

            // check in URL
            if (this.paramters[i].commandSteps[j].target.request.url) {
              const urlRaw = this.paramters[i].commandSteps[j].target.request.url.raw;
              const urlParameters = this.extractParametersFromString(urlRaw, PLACEHOLDER_PATTERN);
              urlParameters.forEach(parameter => {
                suiteHasHashInVar = true;
                const cleanParam = parameter.slice(2, -2); // removes '{{' and '}}'
                currentList.push(this.paramters[i].name + cleanParam);
              });
            }

            // check in request body
            const body = this.paramters[i].commandSteps[j].target.request.body;
            if (body && body.mode) {
              const bodyMode = body.mode;
              switch (bodyMode) {
                case "raw":
                  const rawBodyParameters = this.extractParametersFromString(body.raw, PLACEHOLDER_PATTERN);
                  rawBodyParameters.forEach(parameter => {
                    suiteHasHashInVar = true;
                    const cleanParam = parameter.slice(2, -2); // removes '{{' and '}}'
                    currentList.push(this.paramters[i].name + cleanParam);
                  });
                  break;
                case "formdata":
                  const formDataBodyParameters = this.extractParametersFromAttributes(body.formdata, PLACEHOLDER_PATTERN);
                  formDataBodyParameters.forEach(parameter => {
                    suiteHasHashInVar = true;
                    const cleanParam = parameter.slice(2, -2); // removes '{{' and '}}'
                    currentList.push(this.paramters[i].name + cleanParam);
                  });
                  break;
                case "urlencoded":
                  const urlencodedBodyParameters = this.extractParametersFromAttributes(body.urlencoded, PLACEHOLDER_PATTERN);
                  urlencodedBodyParameters.forEach(parameter => {
                    suiteHasHashInVar = true;
                    const cleanParam = parameter.slice(2, -2); // removes '{{' and '}}'
                    currentList.push(this.paramters[i].name + cleanParam);
                  });
                  break;
                case "file":
                  const fileBodyParameters = this.extractParametersFromString(body.file.src, PLACEHOLDER_PATTERN);
                  fileBodyParameters.forEach(parameter => {
                    suiteHasHashInVar = true;
                    const cleanParam = parameter.slice(2, -2); // removes '{{' and '}}'
                    currentList.push(this.paramters[i].name + cleanParam);
                  });
                  break;
                case "graphql":
                  const gqlQueryBodyParameters = this.extractParametersFromString(body.graphql.query, PLACEHOLDER_PATTERN);
                  gqlQueryBodyParameters.forEach(parameter => {
                    suiteHasHashInVar = true;
                    const cleanParam = parameter.slice(2, -2); // removes '{{' and '}}'
                    currentList.push(this.paramters[i].name + cleanParam);
                  });
                  const gqlVarsBodyParameters = this.extractParametersFromString(body.graphql.variables, PLACEHOLDER_PATTERN);
                  gqlVarsBodyParameters.forEach(parameter => {
                    suiteHasHashInVar = true;
                    const cleanParam = parameter.slice(2, -2); // removes '{{' and '}}'
                    currentList.push(this.paramters[i].name + cleanParam);
                  });
                  break;
              }
            }

          } else {
            let value = this.paramters[i].commandSteps[j].value;
            let value2 = this.paramters[i].commandSteps[j].value2;
            if (Boolean(value) && value.startsWith("@@")) {
              suiteHasHashInVar = true;
              currentList.push(this.paramters[i].name + value);
            }
            if (Boolean(value2) && value2.startsWith("@@")) {
              suiteHasHashInVar = true;
              currentList.push(this.paramters[i].name + value2);
            }
            if (this.paramters[i].commandSteps[j].target) {
              suiteHasHashInVar = this.addParameterInTargetToList(this.paramters[i].commandSteps[j].target, currentList, this.paramters[i].name) ? true : suiteHasHashInVar;
            }
            if (this.paramters[i].commandSteps[j].target2) {
              suiteHasHashInVar = this.addParameterInTargetToList(this.paramters[i].commandSteps[j].target2, currentList, this.paramters[i].name) ? true : suiteHasHashInVar;
            }

            if (Boolean(value))
              mainlist.push(this.paramters[i].name + "@@" + value);
            if (Boolean(value2))
              mainlist.push(this.paramters[i].name + "@@" + value2)
          }

          if (actionName.includes("close statement")) {
            if (loopDepth > 0) loopDepth--; // only close if inside loop
          }
        }
      }
    }
    sheet1 = [...new Set(sheet1)];
    sheet2 = [...new Set(sheet2)];
    return { sheet1, sheet2 };
  }

  addParameterInTargetToList(target, list, stepName): boolean {
    let suiteHasHashInVar = false;
    if (Boolean(target.dom_id) && target.dom_id.startsWith("@@")) {
      suiteHasHashInVar = true;
      list.push(stepName + target.dom_id);
    }
    if (Boolean(target.dom_name) && target.dom_name.startsWith("@@")) {
      suiteHasHashInVar = true;
      list.push(stepName + target.dom_name);
    }
    if (Boolean(target.tag) && target.tag.startsWith("@@")) {
      suiteHasHashInVar = true;
      list.push(stepName + target.tag);
    }
    if (Boolean(target.css) && target.css.startsWith("@@")) {
      suiteHasHashInVar = true;
      list.push(stepName + target.css);
    }
    if (Boolean(target.class) && target.class.startsWith("@@")) {
      suiteHasHashInVar = true;
      list.push(stepName + target.class);
    }
    if (Boolean(target.desc) && target.desc.startsWith("@@")) {
      suiteHasHashInVar = true;
      list.push(stepName + target.desc);
    }
    if (Boolean(target.link) && target.link.startsWith("@@")) {
      suiteHasHashInVar = true;
      list.push(stepName + target.link);
    }
    if (Boolean(target.partial_link) && target.partial_link.startsWith("@@")) {
      suiteHasHashInVar = true;
      list.push(stepName + target.partial_link);
    }
    if (Boolean(target.horizontal_index) && target.horizontal_index.startsWith("@@")) {
      suiteHasHashInVar = true;
      list.push(stepName + target.horizontal_index);
    }
    if (target.xpaths && target.xpaths.length > 0) {
      for (const xpath of target.xpaths) {
        if (Boolean(xpath) && xpath.startsWith("@@")) {
          suiteHasHashInVar = true;
          list.push(stepName + xpath);
        }
      }
    }
    return suiteHasHashInVar;
  }

  downloadAndFeedCSV() {
    this.actionService.getItems().subscribe((data) => {

      let actionItemsList: ActionModel[] = data['data'];

      let { sheet1, sheet2 } = this.getParamList(actionItemsList);

      let nonLoop = sheet1.filter((v, i, arr) => arr.indexOf(v) === i);
      let loop = sheet2.filter((v, i, arr) => arr.indexOf(v) === i);

      const headers: string[] = [...nonLoop, ...loop];

      const typeRow: string[] = [
        ...nonLoop.map(() => "NonLoop"),
        ...loop.map(() => "Loop")
      ];

      const apiUrl = `${this.baseUrl}execute/testData/${this.setLimit}`;
      const payload = { columnNames: headers };

      this.showDiv = !this.showDiv;

      this.http.post(apiUrl, payload).subscribe((response: any) => {

        let array1 = response.data || [];

        const rows: { [key: string]: string[] } = {};
        headers.forEach(h => rows[h] = []);

        array1.forEach((colItem: string) => {
          const colonIndex = colItem.indexOf(':');
          if (colonIndex === -1) return;

          const trimmedHeader = colItem.substring(0, colonIndex).trim();
          let value = colItem.substring(colonIndex + 1).trim();

          value = value.replace(/\n/g, ' ').replace(/\r/g, '');

          if (value.includes(',') || value.includes('"')) {
            value = '"' + value.replace(/"/g, '""') + '"';
          }

          if (rows[trimmedHeader] !== undefined) {
            rows[trimmedHeader].push(value);
          } else {
            const matchedKey = Object.keys(rows).find(
              k => k.toLowerCase() === trimmedHeader.toLowerCase()
            );
            if (matchedKey) {
              rows[matchedKey].push(value);
            }
          }
        });

        const maxRowCount = Math.max(
          0, ...Object.values(rows).map((values: string[]) => values.length)
        );

        let CsvString =
          typeRow.map(h => '"' + h + '"').join(',') + '\r\n' +
          headers.map(h => '"' + h + '"').join(',') + '\r\n';

        for (let i = 0; i < maxRowCount; i++) {
          const row = headers.map(h => {
            const val = rows[h][i] || '';
            return '"' + val.replace(/"/g, '""') + '"';
          });
          CsvString += row.join(',') + '\r\n';
        }

        const csvBlob = new Blob([CsvString], { type: "text/csv;charset=utf-8;" });
        const csvFile = new File([csvBlob], "suite.csv", { type: "text/csv" });

        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(csvBlob);
        downloadLink.download = "suite.csv";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        this.file = csvFile;
        this.csvFileStateChange.emit();
        this.showDialog = false;

      }, (error) => {
        console.error("Error downloading AI data:", error);
      });

    });
  }

  resetUploadedFile(ev) {
    this.resetFile = ev;
    this.file = null;
    this.csvFileChange.emit(null);
    this.csvFileStateChange.emit();
  }

  downloadCsv() {
    if (this.selectedMode === 'manual') {
      this.actionService.getItems().subscribe((data) => {
        let actionItemsList: ActionModel[] = data['data'];

        let { sheet1, sheet2 } = this.getParamList(actionItemsList);

        let nonLoop = sheet1.filter((v, i, arr) => arr.indexOf(v) === i);
        let loop = sheet2.filter((v, i, arr) => arr.indexOf(v) === i);

        const headers: string[] = [...nonLoop, ...loop];

        const typeRow: string[] = [
          ...nonLoop.map(() => "NonLoop"),
          ...loop.map(() => "Loop")
        ];

        let CsvString =
          typeRow.map(h => '"' + h + '"').join(',') + '\r\n' +
          headers.map(h => '"' + h + '"').join(',') + '\r\n';

        CsvString = "data:text/csv;charset=utf-8," + encodeURIComponent(CsvString);
        const downloadLink = document.createElement("a");
        downloadLink.setAttribute("href", CsvString);
        downloadLink.setAttribute("download", "suite.csv");
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });

    } else if (this.selectedMode === 'ai') {

      this.showDialog = !this.showDialog;

      this.actionService.getItems().subscribe((data) => {
        let actionItemsList: ActionModel[] = data['data'];

        let { sheet1, sheet2 } = this.getParamList(actionItemsList);

        let nonLoop = sheet1.filter((v, i, arr) => arr.indexOf(v) === i);
        let loop = sheet2.filter((v, i, arr) => arr.indexOf(v) === i);

        const headers: string[] = [...nonLoop, ...loop];

        const typeRow: string[] = [
          ...nonLoop.map(() => "NonLoop"),
          ...loop.map(() => "Loop")
        ];

        const apiUrl = `${this.baseUrl}execute/testData/${this.setLimit}`;
        const payload = { columnNames: headers };

        this.http.post(apiUrl, payload).subscribe((response: any) => {

          let array1 = response.data || [];

          const rows: { [key: string]: string[] } = {};
          headers.forEach(h => rows[h] = []);

          array1.forEach((colItem: string) => {
            const colonIndex = colItem.indexOf(':');
            if (colonIndex === -1) return;

            const trimmedHeader = colItem.substring(0, colonIndex).trim();
            let value = colItem.substring(colonIndex + 1).trim();

            value = value.replace(/\n/g, ' ').replace(/\r/g, '');

            if (value.includes(',') || value.includes('"')) {
              value = '"' + value.replace(/"/g, '""') + '"';
            }

            if (rows[trimmedHeader] !== undefined) {
              rows[trimmedHeader].push(value);
            } else {
              const matchedKey = Object.keys(rows).find(
                k => k.toLowerCase() === trimmedHeader.toLowerCase()
              );
              if (matchedKey) {
                rows[matchedKey].push(value);
              }
            }
          });

          const maxRowCount = Math.max(
            0, ...Object.values(rows).map((values: string[]) => values.length)
          );

          let CsvString =
            typeRow.map(h => '"' + h + '"').join(',') + '\r\n' +
            headers.map(h => '"' + h + '"').join(',') + '\r\n';

          for (let i = 0; i < maxRowCount; i++) {
            const row = headers.map(h => {
              const val = rows[h][i] || '';
              return '"' + val.replace(/"/g, '""') + '"';
            });
            CsvString += row.join(',') + '\r\n';
          }

          CsvString = "data:text/csv;charset=utf-8," + encodeURIComponent(CsvString);
          const downloadLink = document.createElement("a");
          downloadLink.setAttribute("href", CsvString);
          downloadLink.setAttribute("download", "suite.csv");
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);

        }, (error) => {
          console.error("Error downloading AI data:", error);
        });
      });
    }
  }

  getActionNameById(actionItemsList: ActionModel[], actionId) {
    const action = actionItemsList.find(item => (item._id["$oid"] ? item._id["$oid"] : item._id) === actionId);
    return action ? action.name : "";
  }

  getExecutionUrls(executionUrlType: 'web' | 'mobile' = 'web') {
    if (executionUrlType === 'web') {
      if (this.featureAccessService.getAccess('LOCAL_EXECUTION') !== 'WRITE') {
        this.listofUser = [];
        return;
      }
    } else if (executionUrlType === 'mobile') {
      if (this.featureAccessService.getAccess('MOBILE_AUTOMATION') !== 'WRITE') {
        this.listofUserMobile = [];
        return;
      }
    }
    const projectId = localStorage.getItem("projectId");
    if (!projectId) {
      return;
    }
    this.userService.getLocalExecutionUrls(projectId, executionUrlType).subscribe(
      (response: any) => {
        const list = Array.isArray(response) ? response : [];
        if (executionUrlType === 'mobile') {
          this.listofUserMobile = list;
        } else {
          this.listofUser = list;
        }
      });
  }

  convertEpochToDate(epoch: string): string {
    if (!epoch) {
      return 'N/A';
    }
    const date = new Date(Number(epoch));
    return date.toLocaleString();
  }

  isStatusInactive(lastActiveTime: number | undefined): boolean {
    if (!lastActiveTime) return true; // Default to inactive if no time provided
    const currentTime = Date.now(); // Current time in milliseconds
    const lastActiveInMillis = lastActiveTime; // Convert to milliseconds
    const differenceInMinutes = (currentTime - lastActiveInMillis) / (1000 * 60); // Difference in minutes

    if (differenceInMinutes < 3) {
      return false
    }
    else {
      return true
    }
  }

  hideDialog() {
    this.showDialog = !this.showDialog;
  }

  onModeChange() {
    this.isSetTimeDisabled = this.selectedMode !== 'ai';
    this.isAIGenerated = !this.isAIGenerated;
  }

  /**
   * Hub (Xpeer Mobile Hub checked): POST `{}` to getDeviceDetails.
   * Local host picked: POST `{ localExecutionUrls: ["host…"] }`.
   */
  getMobileDevice(payload?: { localExecutionUrls?: string[] }) {
    if (this.featureAccessService.getAccess('MOBILE_AUTOMATION') !== 'WRITE') {
      this.allEmulators = [];
      this.emulatorList = [];
      this.emulatorStatusMap = {};
      return;
    }
    this.stopEmulatorStatusPolling();
    this.allEmulators = [];
    this.emulatorList = [];
    this.emulatorStatusMap = {};

    const body =
      payload && payload.localExecutionUrls && payload.localExecutionUrls.length > 0
        ? { localExecutionUrls: payload.localExecutionUrls }
        : {};

    this.mobileExecutionService.getMobileExecutionList(body).subscribe((response: any) => {
      if (this.isDestroyed) {
        return;
      }
      if (response && response.operationStatus === 'SUCCESS' && Array.isArray(response.data)) {
        this.allEmulators = response.data.filter((device: any) => this.isAllowedMobileDevice(device));
        this.startEmulatorStatusPolling();
        this.tryApplyPendingScheduleEmulators();
      }
    });
  }

  getEmulatorStatusLabel(emulator: any): string {
    if (!emulator || !emulator._id) {
      return '';
    }
    const entry = this.emulatorStatusMap[emulator._id];
    if (entry == null) {
      return '';
    }
    if (typeof entry === 'string') {
      return entry;
    }
    if (entry.status != null) {
      return String(entry.status);
    }
    return '';
  }

  isEmulatorOptionDisabled(emulator: any): boolean {
    const status = emulator && emulator.status
      ? emulator.status.toString().toLowerCase()
      : '';

    const queued = emulator && emulator.executions_queued
      ? Number(emulator.executions_queued)
      : 0;

    const isOffline =
      status === 'offline' ||
      status === 'unavailable';

    return isOffline || (!isNaN(queued) && queued >= 10);
  }

  private applyEmulatorStatusResponse(response: any): void {
    if (!response || response.operationStatus !== 'SUCCESS' || !response.data || typeof response.data !== 'object' || Array.isArray(response.data)) {
      return;
    }
    this.emulatorStatusMap = { ...response.data };
    const idsFromStatus = new Set(Object.keys(this.emulatorStatusMap));
    const filtered = this.allEmulators.filter((e: any) => e && e._id && idsFromStatus.has(String(e._id)));
    filtered.forEach((e: any) => {
      const entry = this.emulatorStatusMap[String(e._id)];
      if (entry == null) return;

      if (typeof entry === 'string') {
        e.status = entry;
        return;
      }

      // Merge latest status details into the emulator object so the UI updates on every poll.
      // (e.g. status dot + executions_queued)
      Object.assign(e, entry);
      if (entry.status != null) e.status = String(entry.status);
      if (entry.executions_queued != null) e.executions_queued = entry.executions_queued;
    });
    this.emulatorList = filtered.filter((device: any) => this.isAllowedMobileDevice(device));

    const allowed = new Set(this.emulatorList.map((e: any) => e._id));
    if (this.pendingScheduleEmulators && this.pendingScheduleEmulators.length) {
      this.tryApplyPendingScheduleEmulators();
    } else {
      this.selectedEmulators = (this.selectedEmulators || []).filter((s: any) => s && allowed.has(s._id) && !this.isEmulatorOptionDisabled(s));
    }
  }

  /** Re-apply emulators from schedule config after device list loads (edit mode). */
  retryApplyScheduleEmulators(): void {
    this.tryApplyPendingScheduleEmulators();
  }

  private tryApplyPendingScheduleEmulators(): void {
    if (!this.pendingScheduleEmulators || !this.pendingScheduleEmulators.length) {
      return;
    }

    const matched: any[] = [];
    let resolvedFromApi = true;

    this.pendingScheduleEmulators.forEach((apiEmu: any) => {
      const deviceId = apiEmu && apiEmu.device_id ? String(apiEmu.device_id) : '';
      if (!deviceId) {
        resolvedFromApi = false;
        return;
      }

      let emulator = (this.emulatorList || []).find((e: any) => e && String(e._id) === deviceId);
      if (!emulator) {
        emulator = (this.allEmulators || []).find((e: any) => e && String(e._id) === deviceId);
      }
      if (!emulator) {
        resolvedFromApi = false;
        emulator = {
          _id: deviceId,
          device_name: apiEmu.device_name || apiEmu.mobileEmulator || deviceId,
          domain: apiEmu.hub_name || String(apiEmu.mobileHubIp || '').replace(/\.xpeer\.ai$/i, ''),
          platform: apiEmu.mobileOs || 'ANDROID',
          udid: apiEmu.mobileEmulator || '',
          hub_ip: apiEmu.mobileHubIp || '',
          hub_port: apiEmu.mobileHubPort || '',
          hub_name: apiEmu.hub_name || '',
          status: 'online',
          sessionStatus: 'available'
        };
      }
      matched.push(emulator);
    });

    const expected = this.pendingScheduleEmulators.length;
    if (!matched.length || matched.length < expected) {
      return;
    }

    this.selectedEmulators = matched.slice();
    if (this.editMode && this.scheduleAttachedApkPath) {
      this.useDefaultApk = true;
      if (!this.apkFileName) {
        this.apkFileName = this.scheduleAttachedApkLabel;
      }
    }

    if (resolvedFromApi) {
      this.pendingScheduleEmulators = [];
    }
  }

  private applyScheduleAttachedFiles(attachedFiles: any[]): void {
    this.scheduleAttachedCsvPath = null;
    this.scheduleAttachedCsvLabel = '';
    this.scheduleAttachedApkPath = null;
    this.scheduleAttachedApkLabel = '';
    this.scheduleCsvResetRequested = false;
    this.scheduleApkResetRequested = false;

    if (!Array.isArray(attachedFiles) || !attachedFiles.length) {
      return;
    }

    const csvEntry = attachedFiles.find((f: any) => {
      if (!f || !f.storage_path) {
        return false;
      }
      const type = String(f.file_type).toUpperCase();
      return type === 'DATA' || type === 'CSV';
    });
    if (csvEntry) {
      this.scheduleAttachedCsvPath = csvEntry.storage_path;
      this.scheduleAttachedCsvLabel = this.extractStorageFileName(csvEntry.storage_path);
      this.useDefaultCsv = true;
      this.setCsvForSuite = false;
    }

    const apkEntry = attachedFiles.find(
      (f: any) => f && String(f.file_type).toUpperCase() === 'APK' && f.storage_path
    );
    if (apkEntry) {
      this.scheduleAttachedApkPath = apkEntry.storage_path;
      this.scheduleAttachedApkLabel = this.extractStorageFileName(apkEntry.storage_path);
      this.apkFileName = this.scheduleAttachedApkLabel;
      this.useDefaultApk = true;
    }
  }

  private extractStorageFileName(storagePath: string): string {
    if (!storagePath) {
      return 'Attached file';
    }
    const parts = String(storagePath).split('/');
    return parts[parts.length - 1] || storagePath;
  }

  private isAllowedMobileDevice(device: any): boolean {
    if (!device) {
      return false;
    }
    const status = this.normalizeDeviceState(device.status);
    const sessionStatus = this.normalizeDeviceState(device.sessionStatus);
    return status === 'online' && (sessionStatus === 'available' || sessionStatus === 'busy');
  }

  private normalizeDeviceState(value: any): string {
    if (value == null) {
      return '';
    }
    return String(value)
      .toLowerCase()
      .trim()
      .replace(/['"]/g, '');
  }

  private startEmulatorStatusPolling(): void {
    this.stopEmulatorStatusPolling(false);
    if (this.isDestroyed || !this.allEmulators.length) {
      return;
    }

    const poll = () => {
      const ids = this.allEmulators.map((e: any) => e && e._id ? String(e._id) : '').filter(Boolean);
      if (!ids.length) {
        return;
      }
      this.mobileExecutionService.getEmulatorsStatus(ids).subscribe(
        (res: any) => this.applyEmulatorStatusResponse(res),
        () => { /* ignore transient errors; next poll retries */ }
      );
    };

    poll();
    this.emulatorStatusPollSub = interval(10000).subscribe(() => poll());
  }

  private stopEmulatorStatusPolling(clearState: boolean = true): void {
    if (this.emulatorStatusPollSub) {
      this.emulatorStatusPollSub.unsubscribe();
      this.emulatorStatusPollSub = null;
    }
    if (clearState) {
      this.emulatorStatusMap = {};
      this.allEmulators = [];
      this.emulatorList = [];
    }
  }

  isWebExecution(): boolean {
    return this.selectedExecutionTypes.includes('web');
  }

  isMobileExecution(): boolean {
    return this.selectedExecutionTypes.includes('mobile');
  }

  /** Mobile Device + APK: hub mode, or local mode after a host URL is chosen */
  get showMobileDeviceAndApkPanel(): boolean {
    if (!this.isMobileExecution()) {
      return false;
    }
    if (this.runOnXpeerMobileHub) {
      return true;
    }
    return !!(this.selectedLocalMobileExecutionUrls && this.selectedLocalMobileExecutionUrls.length > 0);
  }

  isExecuteDisabled(): boolean {
    if (!this.isMobileExecution()) {
      return false;
    }
    if (!this.showMobileDeviceAndApkPanel) {
      return true;
    }
    const noDevices = !this.selectedEmulators || this.selectedEmulators.length === 0;
    return noDevices || (!this.useDefaultApk && !this.apkFile);
  }

  onEmulatorSelect(emulators: any[]) {
    this.selectedEmulators = emulators || [];
    this.clearApkFile();
  }

  onApkFileSelected(input: HTMLInputElement) {
    const file = input.files && input.files.length > 0 ? input.files[0] : null;
    if (!file) {
      this.clearApkFile(input);
      return;
    }

    const isApk =
      file.name.toLowerCase().endsWith('.apk') ||
      file.type === 'application/vnd.android.package-archive';

    if (!isApk) {
      this.notifys.notify('error', 'Error', 'Please select a valid .apk file.');
      this.clearApkFile(input);
      return;
    }

    this.apkFile = file;
    this.apkFileName = file.name;
    this.setApkForSuite = true;
    this.scheduleAttachedApkPath = null;
    this.scheduleAttachedApkLabel = '';
    this.apkFileChange.emit(file);
    input.value = '';
  }

  clearApkFile(input?: HTMLInputElement) {
    this.apkFile = null;
    this.apkFileName = '';
    this.setApkForSuite = false;
    this.apkFileChange.emit(null);
    if (input) {
      input.value = '';
    }
  }

  onUseDefaultApkChange(useDefault: boolean, apkInput: HTMLInputElement): void {
    if (!useDefault) {
      this.clearApkFile(apkInput);
      setTimeout(() => apkInput.click(), 0);
    } else {
      this.clearApkFile(apkInput);
    }
  }


  onExecutionTypeChange() {
    this.hasManualExecutionTypeChange = true;
    const hadMobileBefore = this.previousExecutionTypes.includes('mobile');
    const hasWeb = this.selectedExecutionTypes.includes('web');
    const hasMobile = this.selectedExecutionTypes.includes('mobile');

    if (!hasWeb && !hasMobile) {
      this.selectedExecutionTypes = this.previousExecutionTypes.slice();
      return;
    }

    if (!hadMobileBefore && hasMobile) {
      this.selectedEmulators = [];
      this.clearApkFile();
      if (this.runOnXpeerMobileHub) {
        this.getMobileDevice();
      } else {
        this.getExecutionUrls('mobile');
      }
    }

    this.previousExecutionTypes = this.selectedExecutionTypes.slice();
    this.executionTypesChange.emit(this.selectedExecutionTypes.slice());

    if (!this.isMobileExecution()) {
      this.selectedEmulators = [];
      this.stopEmulatorStatusPolling();
      this.clearApkFile();
    }
  }

  getStatusClass(status: string, sessionStatus: string): string {
    const normalizedStatus = this.normalizeDeviceState(status);
    const normalizedSessionStatus = this.normalizeDeviceState(sessionStatus);

    if (normalizedStatus === 'online' && normalizedSessionStatus === 'available') {
      return 'status-online';
    }
    if (normalizedStatus === 'online' && (normalizedSessionStatus === 'busy' || normalizedSessionStatus === 'buzy')) {
      return 'status-inuse';
    }
    return 'status-offline';
  }

  /** Apply schedule API master_config onto this execution container UI. */
  applyScheduleMasterConfig(master: any): void {
    if (!master) {
      return;
    }

    const types: string[] = [];
    if (Array.isArray(master.execution_type)) {
      master.execution_type.forEach((t: string) => {
        const lower = (t || '').toLowerCase();
        if (lower === 'web' || lower === 'mobile') {
          types.push(lower);
        }
      });
    }
    const includesMobile = Array.isArray(master.execution_type)
      && master.execution_type.some((t: string) => String(t).toUpperCase() === 'MOBILE');

    if (types.length) {
      this.selectedExecutionTypes = types.slice();
      this.previousExecutionTypes = types.slice();
      this.hasManualExecutionTypeChange = true;
      this.executionTypesChange.emit(this.selectedExecutionTypes.slice());
    }

    this.executionModel.send_mail = !!master.send_notification;
    this.executionModel.screenshot_required = !!master.visual_comparison;
    this.executionModel.is_implicit_default_pause = !!(
      master.is_implicit_default_pause !== undefined && master.is_implicit_default_pause !== null
        ? master.is_implicit_default_pause
        : master.implicitDefaultPause
    );
    
    if (master.default_pause !== undefined && master.default_pause !== null) {
      this.executionModel.default_pause = String(master.default_pause);
    }

    if (master.run_on_xpeer_hub !== undefined) {
      this.executionModel.default_hub = !!master.run_on_xpeer_hub;
    }

    if (master.hub && master.hub !== 'cloud') {
      this.executionModel.hub_ip = master.hub;
    } else if (this.executionModel.default_hub) {
      this.executionModel.hub_ip = environment.selenoidHubIp;
      this.executionModel.execution_machine = 'Default Machine';
    }

    if (master.port !== undefined && master.port !== null) {
      const portNum = Number(master.port);
      if (!isNaN(portNum)) {
        this.executionModel.port = portNum;
        this.exePort = String(portNum);
      }
    } else if (this.executionModel.default_hub) {
      this.executionModel.port = environment.selenoidHubPort;
    }

    if (Array.isArray(master.browsers) && master.browsers.length) {
      this.executionModel.browser = master.browsers.map((b: string) => {
        const s = (b || '').toLowerCase();
        return s.charAt(0).toUpperCase() + s.slice(1);
      });
    }

    if (master.is_default_screen_resolution) {
      this.executionModel.resolution = this.defaultResolution;
    } else if (master.screen_resolution) {
      const res = String(master.screen_resolution);
      const match = BASE_RESOLUTIONS.find(r => r.name === res || r.value === res);
      if (match) {
        this.executionModel.resolution = match.value;
      } else if (res.indexOf('x') >= 0) {
        const parts = res.split('x');
        this.executionModel.resolution = 'custom_resolution';
        this.xDimension = Number(parts[0]) || 1920;
        this.yDimension = Number(parts[1]) || 1080;
      }
    }

    if (master.execution_machine) {
      this.executionModel.execution_machine = master.execution_machine;
    }

    if (Array.isArray(master.emulators) && master.emulators.length) {
      this.pendingScheduleEmulators = master.emulators.slice();
    }

    this.applyScheduleAttachedFiles(master.attached_files);

    if (includesMobile) {
      if (master.run_on_xpeer_hub !== undefined) {
        this.runOnXpeerMobileHub = !!master.run_on_xpeer_hub;
      }
      if (this.runOnXpeerMobileHub) {
        this.getMobileDevice();
      } else {
        this.getExecutionUrls('mobile');
      }
      this.tryApplyPendingScheduleEmulators();
    }
  }

  /** Build schedule create/update master_config from current UI state. */
  getScheduleMasterConfig(): any {
    const model = this.executionModel;
    const executionTypes: string[] = [];
    if (this.isWebExecution()) {
      executionTypes.push('WEB');
    }
    if (this.isMobileExecution()) {
      executionTypes.push('MOBILE');
    }

    let hub = model.hub_ip;
    if (!hub && model.default_hub) {
      hub = environment.selenoidHubIp;
    }
    if (!hub) {
      hub = this.CustomeIP || this.customIp || this.selectedOption || '';
    }

    let port: any = model.port;
    if (port === undefined || port === null || port === '') {
      port = this.exePort ? Number(this.exePort) : environment.selenoidHubPort;
    }
    if (isNaN(Number(port))) {
      port = environment.selenoidHubPort;
    } else {
      port = Number(port);
    }

    const isDefaultScreenResolution = model.resolution === this.defaultResolution;
    let screenResolution = model.resolution;
    if (screenResolution === 'default_resolution') {
      screenResolution = '1920x1200';
    } else if (screenResolution === 'custom_resolution') {
      screenResolution = `${this.xDimension}x${this.yDimension}`;
    } else {
      const match = BASE_RESOLUTIONS.find(r => r.value === screenResolution);
      if (match) {
        screenResolution = match.name;
      }
    }

    const browsers = this.isWebExecution() && model.browser
      ? model.browser.map((b: string) => (b || '').toLowerCase())
      : null;

    const config: any = {
      execution_type: executionTypes,
      hub: hub || environment.selenoidHubIp,
      port: port,
      run_on_xpeer_hub: this.isMobileExecution() ? !!this.runOnXpeerMobileHub : !!model.default_hub,
      send_notification: !!model.send_mail,
      visual_comparison: !!model.screenshot_required,
      is_implicit_default_pause: !!model.is_implicit_default_pause,
      implicitDefaultPause: !!model.is_implicit_default_pause,
      default_pause: model.default_pause != null ? String(model.default_pause) : '0',
      execution_machine: model.execution_machine || null
    };

    if (this.isWebExecution()) {
      config.browsers = browsers;
      config.screen_resolution = screenResolution;
      config.is_default_screen_resolution = isDefaultScreenResolution;
    } else {
      config.browsers = null;
      config.screen_resolution = null;
      config.is_default_screen_resolution = false;
    }

    if (this.isMobileExecution() && this.selectedEmulators && this.selectedEmulators.length) {
      config.emulators = this.selectedEmulators.map(emulator => ({
        device_id: emulator._id,
        mobileOs: emulator.platform,
        mobileEmulator: emulator.udid,
        mobileHubIp: emulator.domain ? emulator.domain + '.xpeer.ai' : emulator.hub_ip,
        mobileHubPort: emulator.hub_port != null
          ? String(emulator.hub_port)
          : (emulator.system_port != null ? String(emulator.system_port) : ''),
        hub_name: emulator.hub_name || emulator.domain || '',
        device_name: emulator.device_name || emulator.udid || ''
      }));
    } else {
      config.emulators = null;
    }

    const attachedFiles: any[] = [];
    if (this.editMode && this.scheduleAttachedCsvPath && !this.scheduleCsvResetRequested) {
      attachedFiles.push({
        file_type: 'DATA',
        storage_path: this.scheduleAttachedCsvPath
      });
    }
    if (this.editMode && this.scheduleAttachedApkPath && !this.scheduleApkResetRequested) {
      attachedFiles.push({
        file_type: 'APK',
        storage_path: this.scheduleAttachedApkPath
      });
    }
    config.attached_files = attachedFiles.length ? attachedFiles : null;

    return config;
  }
}